import React from 'react';
import {Button, Input, Tag} from 'antd';
import {CloseOutlined} from '@ant-design/icons';
import {formatFileSize} from '../../utils/file';
import {FileThumbnail} from '../FileThumbnail';

const {TextArea} = Input;

interface SearchBoxProps {
  keywords: string;
  setKeywords: (value: string) => void;

  tags: string[];
  setTags: (value: string[]) => void;

  loading?: boolean;

  files?: File[];

  onSearch: () => void;

  onRemoveFile: (file: File) => void;
  onPasteFile: (event: React.ClipboardEvent<HTMLTextAreaElement>) => void;
  onReset: () => void;
}

export function SearchBox({
                            keywords,
                            setKeywords,
                            tags,
                            setTags,
                            loading,
                            onSearch,
                            files = [],
                            onRemoveFile,
                            onPasteFile,
                            onReset
                          }: SearchBoxProps) {
  return (
    <div className="drive-search-box">
      <div className="drive-search-box__chips">
        {tags.length > 0 && (
          <div className="drive-search-box__tags">
            {tags.map((tag: string) => (
              <Tag
                key={tag}
                closable
                onClose={() => {
                  setTags(tags.filter((t: string) => t !== tag));
                }}
              >
                {tag}
              </Tag>
            ))}
          </div>
        )}

        {files.length > 0 && (
          <div className="drive-search-box__attachments">
            {files.map((file: File) => (
              <div
                key={`${file.name}-${file.size}-${file.lastModified}`}
                className="drive-search-box__attachment"
              >
                <FileThumbnail file={file}/>
                <div className="drive-search-box__attachment-name">
                  {file.name}
                </div>
                <div className="drive-search-box__attachment-size">
                  {formatFileSize(file.size)}
                </div>
                <CloseOutlined
                  className="drive-search-box__attachment-remove"
                  onClick={() => onRemoveFile(file)}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <TextArea
        className="drive-search-box__textarea"
        value={keywords}
        onChange={e => setKeywords(e.target.value)}
        onPaste={onPasteFile}
        placeholder="请输入搜索内容"
        bordered={false}
        autoSize={{minRows: 3, maxRows: 5}}
      />

      <div className="drive-search-box__footer">
        <Button shape="round" loading={loading} onClick={onReset}>重置</Button>
        <Button type="primary" shape="round" loading={loading} onClick={onSearch}>搜索</Button>
      </div>
    </div>
  );
}
